// @flow

import React, { Component } from 'react';
import moment from 'moment';
import styler from 'react-styling';
import radium from 'radium';
import $ from 'jquery';
import _ from 'lodash/lang';
import 'fullcalendar';
import 'fullcalendar/dist/fullcalendar.min.css';
import { CalendarHeader, EventModal } from './index';
import breakpoints from '../../css/breakpoints';

const style = styler `
  Calendar
    position: fixed
    overflow-y: scroll
    height: calc(100% - 312px)
    width: calc(100% - 534px)
    @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
      width: calc(100% - 40px)
      height: calc(100% - 283px)
    @media screen and (max-width: ${breakpoints.SMALL_AND_ABOVE}px)
      margin-top: 15px
  `;

let calendarPreviousDate;
let calendarPreviousView;

export class FullCalendar extends Component {
  state = {
    showModal: false,
    calEvent: { required: 0, optional: 0 },
  };

  componentDidMount() {
    const locale = this.props.languagedata.locale;

    this.fullcalendar().fullCalendar({
      header: false,
      firstDay: 1,
      locale,
      timeFormat: 'H:mm',
      timezone: 'local',
      defaultView: this.props.initialView,
      events: this.props.events,
      eventClick: (calEvent) => {
        this.setState({
          showModal: true,
          calEvent,
        });
      },
      eventRender: (event, element) => {
        const eventCopy = _.cloneDeep(event);
        const view = this.fullcalendar().fullCalendar('getView').type;
        const eventDay = eventCopy.start.startOf('day').format('LL');
        const currentDay = moment().startOf('day').format('LL');
        if (view === 'listWeek' && eventDay === currentDay) {
          element.css('background-color', '#EAEFFA');
        }
        // Check if event is not confirmed
        if (event.responseType !== 'Accepted' && event.responseType !== 'Organizer' && event.responseType !== 'TentativelyAccepted') {
          element.css('color', 'rgba(0, 0, 0, 0.5)');
        }
        // attach event location
        if (event.location.displayName) {
          const location = `<td>${event.location.displayName}</td>`;
          element.append(location);
        } else {
          const location = '<td></td>';
          element.append(location);
        }
      },
      eventAfterAllRender: () => {
        $('.fc-list-heading .fc-widget-header').attr('colspan', '4');
      },
    });
    if (calendarPreviousDate) {
      this.fullcalendar().fullCalendar('changeView', calendarPreviousView, calendarPreviousDate._i);
    }
  }

  componentWillReceiveProps = (nextProp: Object) => {
    // TODO do something to filter whether anything has actually changed with
    // the events here? Would this help performance?
    this.fullcalendar().fullCalendar('removeEvents');
    this.fullcalendar().fullCalendar('renderEvents', nextProp.events);
  }

  componentWillUnmount() {
    this.fullcalendar().fullCalendar('destroy');
  }

  getCurrentFullCalendarInterval = () => {
    const currentView = this.fullcalendar().fullCalendar('getView');
    // jquery fullcalender returns so called Ambiguously zoned moments...
    // https://fullcalendar.io/docs/utilities/Moment/#ambiguously-zoned They
    // report themselfs as utc but have a date string in the local timezone...
    // This means that calling .utc() on them does nothing but calling .unix()
    // gives a timestamp of the local time.  This is the best way I could fine
    // to coerce them to the local timezone... I don't like it either!
    const start = moment(currentView.intervalStart.format('YYYY-MM-DD HH:mm:ss'));
    const end = moment(currentView.intervalEnd.format('YYYY-MM-DD HH:mm:ss'))
      .subtract(1, 'second');
    calendarPreviousDate = start;
    return { start, end };
  }

  setCalendarView = (view: string) => {
    if (view === 'today') {
      this.fullcalendar().fullCalendar('today');
      const interval = this.getCurrentFullCalendarInterval();
      this.props.updateEvents(interval);
    } else {
      this.fullcalendar().fullCalendar('changeView', view);
      const interval = this.getCurrentFullCalendarInterval();
      calendarPreviousView = view;
      this.props.updateEvents(interval);
    }
  }

  props: {
    initialView: string,
    languagedata: Object,
    endDate: moment,
    startDate: moment,
    events: [{
      title: string,
      location: string,
      required: string[],
      optional: string[],
      chair: string,
    }],
    updateEvents: Function,
  }
  calendar: HTMLDivElement;

  fullcalendar = () => {
    const calendar = this.calendar;
    return $(calendar);
  }

  scrollCalendar = (direction: string) => {
    this.fullcalendar().fullCalendar(direction);
    const interval = this.getCurrentFullCalendarInterval();
    this.props.updateEvents(interval);
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  render() {
    const lang = this.props.languagedata;
    return (
      <div>
        <CalendarHeader
          languagedata={lang}
          calendarView={this.props.initialView}
          setCalendarView={this.setCalendarView}
          scrollCalendar={this.scrollCalendar}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          monthView
          weekView
          dayView
        />

        <div ref={(c) => { this.calendar = c; }} style={style.Calendar}>{''}</div>

        {this.state.showModal ? (
          <EventModal
            event={this.state.calEvent}
            show={this.state.showModal}
            close={this.closeModal}
            languagedata={lang}
          />
        ) : null }
      </div>
    );
  }

}


export default radium(FullCalendar);



// WEBPACK FOOTER //
// ./src/js/Components/FullCalendar.js